import { Component, signal, OnInit, inject, effect } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { OtelService } from './services/otel.service';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  protected readonly title = signal('Neo.Genesis.Portal');
  private router = inject(Router);
  private otelService = inject(OtelService);
  private authService = inject(AuthService);

  constructor() {
    this.otelService.initialise();
    this.otelService.instrumentRouter(this.router);
    // Tags spans with the signed-in Neo staff member once auth resolves, and
    // clears it again on logout - authService.user() already goes null then.
    effect(() => this.otelService.setCurrentUserId(this.authService.user()?.id));
  }

  ngOnInit() {
    // Handle post-login redirect after Angular is fully initialized
    this.handlePostLoginRedirect();
  }

  private handlePostLoginRedirect() {
    const needsRedirect = sessionStorage.getItem('needsPostLoginRedirect');
    if (needsRedirect === 'true') {
      console.log('Handling post-login redirect...');

      // Clear the flag immediately to prevent loops
      sessionStorage.removeItem('needsPostLoginRedirect');

      // Get the stored redirect path
      const redirectPath = sessionStorage.getItem('postLoginRedirectPath') || '/restricted/dashboard';
      console.log('Redirecting to:', redirectPath);

      // Clear the stored path
      sessionStorage.removeItem('postLoginRedirectPath');

      // Add a small delay to ensure the router is ready
      setTimeout(() => {
        this.router.navigate([redirectPath]);
      }, 100);
    }
  }
}
